import Header from '../components/header/Header';
import { Outlet } from 'react-router-dom';
import Footer from '../components/footer/Footer';

const Layout = () => {
  return (
    <div className='body_wrapper'>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
